module.exports = __webpack_public_path__ + "static/img/ureter-detail-1.62ad219.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-detail-1.jpg
// module id = gwnR
// module chunks = 52